import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { metadataService, DocumentApi } from "../_services";
import {
    Row,
    Col
} from "reactstrap";
import { SlBusyIndicator, SlPageTitle } from "./editors";
import { FaFileAlt } from "react-icons/fa";

import { profileActions } from "../_actions";
import DocumentUpload from "./DocumentUpload";
import DocumentList from "./subcomponents/DocumentList";
import NotificationModal from "./subcomponents/NotificationModal";


function SecureUpload({ userHash, loadProfile, profileLoaded, ...props }) {
    const [documents, setDocuments] = useState([]);
    const [isBusy, setIsBusy] = useState(false);
    const [notificationModalOpen, setNotificationModalOpen] = useState(false);

    const isGuest = props.isGuest || (!metadataService.isNullOrEmpty(userHash) && !profileLoaded);

    useEffect(() => {
        if (!isGuest) {
            if (metadataService.isNullOrEmpty(userHash)) {
                loadProfile();
            } else if (profileLoaded) {
                getDocuments();
            }
        }
    }, [userHash]);

    const getDocuments = () => {
        if (!isGuest) {
            setIsBusy(true);
            DocumentApi.getUploadedUserDocuments(userHash).then(response => {
                if (response.data) {
                    setDocuments(response.data);
                }
            }).catch((err) => setIsBusy(false))
                .finally(() => setIsBusy(false))
        } else {
            setIsBusy(false);
        }
    }

    const onDone = (model) => {
        if (isGuest) {
            setDocuments([
                ...documents,
                {
                    originName: model.OriginFileName,
                    documentStatusId: DocumentApi.DOCUMENT_STATUS_NEW,
                    creationTime: model.ReceivedDateTime,
                    modifiedTime: model.ReceivedDateTime,
                }
            ]);
        }
            
        setNotificationModalOpen(true);
    }

    const onCloseModal = () => {
        setNotificationModalOpen(false);
        setTimeout(() => {
            getDocuments();
        }, 2500);
    } 

    return <React.Fragment>
        <Row>
            <Col>
                <SlPageTitle pageName="DocumentSecureUpload" />
                <p dangerouslySetInnerHTML={{ __html: metadataService.getMessage("DocumentSecureUpload") }}></p>
            </Col>
        </Row>
        {!metadataService.isNullOrEmpty(userHash) && isBusy !== true ?
            <React.Fragment>
                <Row>
                    <Col>
                        <DocumentUpload
                            uploadTitle={null}
                            hideTitle={true}
                            hideStatus={true}
                            leadId={null}
                            origin={DocumentApi.DOCUMENT_ORIGIN_UPLOAD}
                            documentStatus={""}
                            documentStatusClass={""}
                            documentClassification={DocumentApi.DOCUMENT_CLASSIFICATION_UNKNOWN}
                            onDone={onDone}
                            hideDropZone={false}
                            lastModified={""}
                            maxAllowedFiles={5}
                            restoreOnDone={true}
                            userHash={userHash}
                        />
                    </Col>
                </Row>
                {documents.length > 0 && (
                    <Row>
                        <Col>
                            <DocumentList
                                dataSource={documents}
                                openFileNewTab={null}
                                leftContent={<FaFileAlt size={60} />}
                            />
                        </Col>
                    </Row>
                )}
            </React.Fragment>
            :
            <Row>
                <Col className={"text-center"}>
                    <SlBusyIndicator visible={true} />
                </Col>
            </Row>
        }
        <NotificationModal
            open={notificationModalOpen}
            ok={onCloseModal}
            message={metadataService.getMessage("DocumentUploadSuccessful")}
        />
    </React.Fragment>
}

const mapStateToProps = (state, ownProps) => {
    const { language } = state.users;
    const { userProfile } = state.profile;
    return {
        language,
        userHash: ownProps.userHash || userProfile.userHash,
        profileLoaded: state.profile.profileLoaded
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadProfile: () => dispatch(profileActions.loadProfile())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecureUpload);
